import styled from 'styled-components';

export const HeadDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  #specialist-avatar {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
    border-radius: 80px;
  }

  #specialist-name {
    font: 18px Montserrat;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
    color: #555658;
  }

  #specialist-code {
    font: 16px Montserrat;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #898b8e;
  }
`;

export const BodyDetails = styled.div`
  margin-bottom: 32px;
`;

export const WrapperDetail = styled.div`
  display: flex;
  align-items: flex-start;

  #detail-icon {
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }

  div #detail-name {
    font: 14px Montserrat;
    font-weight: 500;
    line-height: 22px;
    color: #898b8e;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background-color: #d5d5d6;
`;

export const CurriculumButton = styled.button`
  height: 40px;
  width: 60%;
  background-color: white;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border-color: #004f92;
  border-width: 1px;
  align-self: center;
  cursor: pointer;
  margin-top: 16px;

  p {
    font: 16px Montserrat;
    color: #004f92;
    font-weight: 500;
  }
`;
